import { Component, OnInit } from '@angular/core';
import {UserCookiesService} from "./user-cookies.service";
import { UserPrivacyService } from '../user-privacy/user-privacy.service';

@Component({
  selector: 'pbc-user-cookies',
  templateUrl: './user-cookies.component.html',
  styleUrls: ['./user-cookies.component.scss']
})
export class UserCookiesComponent implements OnInit {

  showUserCookies : boolean = false;

  constructor(
    private userCookiesService : UserCookiesService,
    private userPrivacyService : UserPrivacyService
  ) { }

  ngOnInit() {
    this.userCookiesService.showCookies.subscribe((show : boolean) => {
      this.showUserCookies = show;
    })
  }

  closeUserCookiesPopupClick() {
    this.showUserCookies = false;
  }

  showPrivacyClick() {
    this.userPrivacyService.showPrivacyRulesPopup(true);
  }

}
